import { PLOT_AREA_HOVER, PLOT_AREA_CLICK } from '../constants';

var PlotAreaEventsMixin = {
    hover: function(chart, e) {
        this._dispatchEvent(chart, e, PLOT_AREA_HOVER);
    },

    click: function(chart, e) {
        this._dispatchEvent(chart, e, PLOT_AREA_CLICK);
    }
};

export default PlotAreaEventsMixin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/chart/mixins/plotarea-events-mixin.js
// module id = 292
// module chunks = 29